// extracted by mini-css-extract-plugin
module.exports = {"container":"_34NyX8fi","overlayed":"_3jTCR2pn","spinner":"_1SrbYmOo","content":"kL-sKLzw"};